import type { ReactNode } from "react";

interface SheetProps {
  title: string;
  children: ReactNode;
  actions: ReactNode;
  onDismiss?: (() => void) | undefined;
}

/** A bottom sheet over the current screen — never a full navigation. */
export function Sheet({ title, children, actions, onDismiss }: SheetProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="absolute inset-0 bg-black/60"
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="relative w-full max-w-[480px] rounded-t-[20px] border-t border-border bg-surface px-5 pb-6 pt-5"
      >
        <h2 className="m-0 font-[family-name:var(--font-display)] text-[18px] font-bold">
          {title}
        </h2>
        <div className="pt-2.5">{children}</div>
        <div className="flex flex-col gap-2.5 pt-5">{actions}</div>
      </div>
    </div>
  );
}
